import { cardActionsClasses, cardClasses, cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "core/themes/src/definitions/components.types"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {
        root: {
            [`.${cardClasses.root}`]: {
                [`.${cardHeaderClasses.root}`]: {
                    [`.${cardHeaderClasses.content}`]: {
                        [`.${typographyClasses.root}`]: {
                            fontSize: "1.5rem",
                        },
                    },
                },
            },
        },
    },
    variants: [
        {
            props: { widgetVariant: "dashboard" },
            style: {
                [`.${cardClasses.root}`]: {
                    backgroundImage: "url(/styles/default/images/widget-bg-vouchers-s.png)",
                    [`.${cardActionsClasses.root}`]: {
                        padding: "0 1em 1em",
                    },
                },
            },
        },
    ],
})
